"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var icon_1 = require("../icon");
var Chip = /** @class */ (function (_super) {
    tslib_1.__extends(Chip, _super);
    function Chip(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onDelete = function (e) {
            var _a = _this.props, onDelete = _a.onDelete, value = _a.value, label = _a.label, item = _a.item, id = _a.id;
            utils_1.pauseEvent(e);
            onDelete(value, label, item, id);
        };
        _this.onHandlerClick = function () {
            var _a = _this.props, onHandlerClick = _a.onHandlerClick, value = _a.value, label = _a.label, item = _a.item;
            onHandlerClick && onHandlerClick(value, label, item);
        };
        return _this;
    }
    Chip.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, className = _b.className, theme = _b.theme, value = _b.value, label = _b.label, onDelete = _b.onDelete, fill = _b.fill, blue = _b.blue, orange = _b.orange, purple = _b.purple, deepPurple = _b.deepPurple, invert = _b.invert, active = _b.active, handlerIconName = _b.handlerIconName, onHandlerClick = _b.onHandlerClick, link = _b.link, hideDeleteButton = _b.hideDeleteButton, others = tslib_1.__rest(_b, ["children", "className", "theme", "value", "label", "onDelete", "fill", "blue", "orange", "purple", "deepPurple", "invert", "active", "handlerIconName", "onHandlerClick", "link", "hideDeleteButton"]);
        var classes = classnames_1.default(theme.chip, className, (_a = {},
            _a[theme.fill] = fill,
            _a[theme.blue] = blue,
            _a[theme.orange] = orange,
            _a[theme.purple] = purple,
            _a[theme.deepPurple] = deepPurple,
            _a[theme.invert] = invert,
            _a[theme.active] = active,
            _a[theme.noDeleteButton] = hideDeleteButton,
            _a));
        var handler = null;
        if (handlerIconName) {
            handler = (React.createElement("div", { className: theme.handler, onClick: this.onHandlerClick },
                React.createElement(icon_1.default, { iconName: handlerIconName, size: 1.4 })));
            if (link && this.context.linkComponent) {
                var LinkComponent = this.context.linkComponent;
                handler = React.createElement(LinkComponent, tslib_1.__assign({}, link), handler);
            }
        }
        var hasWhiteSpaces = value && utils_1.hasWhiteSpace(value);
        return (React.createElement("div", tslib_1.__assign({ className: classes }, others, { "data-value": value, "data-ui": "chip" }),
            handler,
            React.createElement("div", { className: theme.label },
                label,
                " ",
                hasWhiteSpaces && React.createElement("div", { style: { fontSize: 10 } }, "(Value contains whitespaces)")),
            !hideDeleteButton
                ? (React.createElement("div", { className: theme.close, onClick: this.onDelete },
                    React.createElement(icon_1.default, { iconName: "icon-cancel-small", size: 1.2 })))
                : null));
    };
    Chip.defaultProps = {
        onDelete: utils_1.noop
    };
    Chip.contextTypes = {
        linkComponent: PropTypes.any
    };
    return Chip;
}(React.Component));
exports.default = Chip;
